<div class="fullcontainer">
  <br />
  <br />
  <div class='titleContainer'>
    <h2 class='header'>Inspection Types</h2>
    <div>
      <button class='btn btn-secondary' routerLink='/workshop/inspection-types/new'><i class="fas fa-plus"></i> New</button>&nbsp;
    </div>
  </div>
  <br />
  <p class='text-muted'>
    MOTs and every other inspection the workshop schedules. Changing an interval applies from the next time
    that inspection is marked done; switch a type off rather than removing it, so its history stays.
  </p>
  <br />
  <app-grid entity='inspection-type' [columns]='this.columns' [buttons]='this.buttons'
    [searchFilters]='this.searchFilters' [searchFields]='this.searchFields' sortColumn='name' sortDirection='asc'></app-grid>
</div>
